import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import LeftGraphicsImage from "../../assets/images/LeftGraphics.png";
import RightGraphicsImage from "../../assets/images/RightGraphics.png";
import Diff1 from "../../assets/icons/Diff1.png";
import Diff2 from "../../assets/icons/Diff2.png";
import Diff3 from "../../assets/icons/Diff3.png";
import Diff4 from "../../assets/icons/Diff4.png";
import Diff5 from "../../assets/icons/Diff5.png";
import ArrowTwo from "../../assets/icons/Arrow 3.png";
import BackgroundImage from "../../assets/images/AbstractImg.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MapImage from "../../assets/images/MapImage.png";
import { Link } from "react-router-dom";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const ourDiff = [
  {
    id: 1,
    title: "Unparalleled Understanding of Marketing and Business Issues",
    description:
      "Drawing from diverse industry experience, we offer unmatched expertise in understanding and resolving maketing and business issues - be it branding, communication, innovation, GTM or digital...",
    link: "/Whatwedo",
    icon: Diff1,
  },
  {
    id: 2,
    title: "Multi-Source Data Integration",
    description:
      "In an era where data flows from countless sources, businesses face the challenge of turning this vast information into actionable insights...",
    link: "/Whatwedo2",
    icon: Diff2,
  },
  {
    id: 3,
    title: "On-Demand Analytics",
    description:
      "Empowering businesses with innovative on-demand analytics, we redefine decision-making in today's world...",
    link: "/Whatwedo3",
    icon: Diff3,
  },
  {
    id: 4,
    title: "Effective Visualization",
    description:
      "Empower your decision-making with our advanced dashboarding solutions that allow to you present your data to your internal stakeholders in a concise and actionable way...",
    link: "/Whatwedo4",
    icon: Diff4,
  },
  {
    id: 5,
    title: "Diverse & Uber Senior 'Glo-cal' Consulting Expertise",
    description:
      "Inteliphyle offers a blend of diverse, very senior-level expertise, that is able to address both global and local challenges - making it well-positioned to cater to differing client needs across various regions and industries. Partner with us to navigate industry complexities smoothly, and drive growth with confidence...",
    link: "/Whatwedo5",
    icon: Diff5,
  },
];

const AboutUsOurDifferentiation = () => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: { xs: "2rem", sm: "3.5rem" },
        // height: { xs: "80rem", sm: "initial" },
        position: "relative",
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        overflow: "hidden",
      }}
    >
      {/* Right Graphics Image */}
      <Box
        sx={{
          position: "absolute",
          top: "5%",
          right: { xs: "-240%", sm: "-60%" },
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={RightGraphicsImage}
          alt="Right Graphics"
          sx={{
            width: { xs: "40%", sm: "60%" },
            maxWidth: "none",
            transform: "translate(10%, -10%)",
          }}
        />
      </Box>

      {/* Left Graphics Image */}
      <Box
        sx={{
          position: "absolute",
          top: "5%",
          left: { xs: "-50%", sm: "-25%" },
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={LeftGraphicsImage}
          alt="Left Graphics"
          sx={{
            width: "60%",
            maxWidth: "none",
          }}
        />
      </Box>

      <Box
        sx={{
          width: { xs: "100%", sm: "100%" },
          padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "4rem", sm: "2rem" },
            margin: "0 auto",
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
            textAlign: "center",
          }}
        >
          WHAT SETS US APART
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
            textAlign: "center",
          }}
        >
          Our{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>Differentiation</span>
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          margin: { xs: "1.5rem auto", sm: "3rem auto" },

          // height: { xs: "60rem", sm: "50rem" },
          position: "relative",
          zIndex: 2, // Ensure the content is above the background image
        }}
      >
        <Box
          sx={{
            display: "flex",
            maxWidth: { xs: "90%", sm: "100%", md: "80%", xl: "1440px" },
            margin: "0 auto",
            gap: { xs: "1rem", sm: "2rem 1rem", md: "2rem 4rem" },
            flexWrap: "wrap",
            justifyContent: { xs: "center", sm: "center" },
          }}
        >
          {/* Repeated Card Box */}
          {ourDiff.map((ourDiffData) => (
            <Link to={ourDiffData.link} style={{ textDecoration: "none" }}>
              <Box
                key={ourDiffData.id}
                sx={{
                  width: { xs: "10rem", sm: "21rem" },
                  height: { xs: "14rem", sm: "23rem" },
                  borderRadius: "1rem",
                  backgroundColor: "#ecebeb",
                  padding: { xs: "1rem", sm: "1.2rem" },
                  zIndex: "10",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Box sx={{ width: { xs: "2.5rem", sm: "3.6rem" } }}>
                  <img src={ourDiffData.icon} alt="" width="100%" />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Plus Jakarta Sans",
                        fontSize: { xs: "0.8rem", sm: "1.2rem" },
                        fontWeight: "500",
                        color: "rgba(51, 51, 51, 1)",
                        marginTop: "1rem",
                      }}
                    >
                      {ourDiffData.title}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Plus Jakarta Sans",
                        fontSize: { xs: "0.7rem", sm: "0.8rem" },
                        color: "rgba(51, 51, 51, 1)",
                        marginTop: "0.2rem",
                        display: { xs: "none", sm: "block" },
                      }}
                    >
                      {ourDiffData.description}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "auto",
                    paddingTop: "1rem",
                  }}
                >
                  <Knowmorebtn content="Know More" link={ourDiffData.link} />
                  <Box
                    sx={{
                      width: "2.2rem",
                      height: "2rem",
                      display: { xs: "none", sm: "flex" },
                      alignItems: "center",
                    }}
                  >
                    <img src={ArrowTwo} alt="" width="100%" />
                  </Box>
                </Box>
              </Box>
            </Link>
          ))}
        </Box>

        {/* Background Image positioned at the bottom */}
      </Box>

      <Box
        sx={{
          position: "absolute",
          // top: { xs: "78%", sm: "68%" },
          top: { xs: "76%", sm: "72%" },
          left: { xs: "1rem", sm: "3rem" },
          zIndex: "2",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: { xs: "1rem", md: "1.2rem" },
            marginBottom: { xs: "1rem", md: "1.2rem" },
            display: "block",
          }}
        >
          Our Team's{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>
            Global Expertise!{" "}
          </span>
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: { xs: "none", sm: "flex" },
          position: "absolute",
          bottom: { xs: "40%", sm: "32rem" },
          zIndex: 1, // Background image should be below the content
        }}
      >
        <img src={BackgroundImage} alt="Background" width="100%" />
      </Box>

      <Box
        sx={{
          width: "100%",
          position: "relative", // To allow background image to be positioned properly
          overflow: "hidden", // Ensure nothing overflows out
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: "0%", sm: "10%" },
            left: 0,
            width: "100%",
            // height: { xs: "12rem", sm: "32rem" },
            zIndex: 2,
          }}
        >
          <LazyLoadImage
            src={BackgroundImage}
            effect="blur"
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
              opacity: 0.7, // Slight opacity for the background image
            }}
          />
        </Box>

        <Box
          sx={{
            width: { xs: "90%", sm: "100%" },
            margin: "0 auto",
            // height: "auto",
            zIndex: 3, // Ensures form content is above the background image
            position: "relative", // Required for layering over the background
            top: "50px",
          }}
        >
          <Box
            sx={{
              margin: "0 auto",
              width: "auto",
              height: { xs: "20rem", sm: "32rem" },
              backgroundColor: "transparent",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LazyLoadImage
              src={MapImage}
              effect="blur"
              width="auto"
              height="100%"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsOurDifferentiation;
